import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack, useNotifications } from "sprint-common-web";

import { useOrdersModuleApi } from "../../common/useOrdersModuleApi";

interface CompleteRejectedOrderFormInputs {
    completionDetails: string;
}

export interface CompleteRejectedOrderFormProps {
    orderId: string;
    onCancel(): void;
    onSubmit(completionDetails?: string): void;
}

export const CompleteRejectedOrderForm: React.VFC<CompleteRejectedOrderFormProps> = ({
    orderId,
    onCancel,
    onSubmit
}: CompleteRejectedOrderFormProps) => {
    const { control, errors, formState, handleSubmit } = useForm<CompleteRejectedOrderFormInputs>({
        defaultValues: {
            completionDetails: ""
        },
        criteriaMode: "all"
    });

    const { success } = useNotifications();
    const { completeRejectedOrder } = useOrdersModuleApi();

    const handleCompletion = async ({ completionDetails }: CompleteRejectedOrderFormInputs) => {
        await completeRejectedOrder({ orderId, statusDetails: completionDetails });

        onSubmit(completionDetails);
        success("Order completed");
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleCompletion)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Completion details"
                            control={control}
                            name="completionDetails"
                            errors={errors}
                            multiline={true}
                        />
                        <FormActions onCancel={onCancel} isLoading={formState.isSubmitting || formState.isValidating} />
                    </FormFields>
                </Stack>
            </Form>
        </Stack>
    );
};
